<script setup lang="ts">
import { useWindowSize } from "@vueuse/core";
import { computed } from "vue";
import { Toaster } from "vue-sonner";
import { useNotifications } from "./useNotifications";

const { width } = useWindowSize();
const { blocker, dismiss } = useNotifications();

const gap = computed(() => width.value * 0.01);

const hideBlocker = () => {
	if (!blocker.value || !blocker.value.dismissible) return;

	dismiss(blocker.value.id);
};

// @TODO: Apply params from theme
</script>

<template>
	<div>
		<Toaster
			position="top-center"
			close-button
			close-button-position="top-right"
			:style="{ '--width': '98vw' }"
			:offset="gap"
			:mobile-offset="gap * 2"
			:gap="gap"
			:duration="Infinity"
			:hotkey="undefined"
			:swipe-directions="['left', 'right']"
			:visible-toasts="5"
		/>
		<Transition name="notifications-blocker" appear>
			<div v-if="blocker" data-sonner-blocker @click="hideBlocker" />
		</Transition>
	</div>
</template>

<style lang="scss">
  @use './notifications.scss';
</style>
